import { render, staticRenderFns } from "./EndpointsForm.vue?vue&type=template&id=573ebdb5&scoped=true&"
import script from "./EndpointsForm.vue?vue&type=script&lang=js&"
export * from "./EndpointsForm.vue?vue&type=script&lang=js&"
import style0 from "./EndpointsForm.vue?vue&type=style&index=0&id=573ebdb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ebdb5",
  null
  
)

export default component.exports